import React from 'react';
import { Alert, Space } from 'antd';
import { useGetCardHolder } from '~/controllers/cardholder';
import useGetAllValuesUpdated from '~/controllers/useGetAllValuesUpdated';
import { UnorderedList } from '~/components';
import WizardContinueButton from './WizardContinueButton';

function AlertWithContiniueButton(props: any) {
  const { formName } = props;
  const cardholderGeneralMessages = useGetCardHolder();
  const isAllValuesUpdated = useGetAllValuesUpdated(cardholderGeneralMessages?.data);
  const cardholderBusinessData = cardholderGeneralMessages?.data?.detailedRejectionCommentsFromBusiness;
  return (
    <>
      <Space direction="vertical" size={80}>
        {!!cardholderBusinessData?.length && (
          <div style={{ position: 'absolute', top: 0, minWidth: '70%', textAlign: 'left' }}>
            <Alert
              key="test"
              description={
                cardholderBusinessData.length === 1 ? (
                  cardholderBusinessData[0]
                ) : (
                  <div style={{ marginLeft: -40, marginTop: 10 }}>
                    <UnorderedList values={cardholderBusinessData} />
                  </div>
                )
              }
              message="comments"
              type="info"
              showIcon
            />
          </div>
        )}

        <Space direction="vertical" size={20}>
          {cardholderGeneralMessages?.data?.errors?.map((item: any) => (
            <Alert key={item} type="warning" message={item?.cardHolderErrorMessage} />
          ))}
          <WizardContinueButton disabled={isAllValuesUpdated} id="cardHolder_continueButton" formName={formName} />
        </Space>
      </Space>
    </>
  );
}
export default AlertWithContiniueButton;
